/**
 * first_run_controller.js — reports that the first-run dashboard was shown (Stimulus).
 *
 * Attached to the hero in templates/components/dashboard_first_run.html, which
 * renders only while the business has no quote. Reports first_run_shown through
 * _onboarding_beacon.js once per browser session per business: a Turbo restore
 * or a page-check swap reconnects the controller, and those are the same
 * showing, not new ones. No listeners, so nothing to clean up in disconnect().
 */
import { Controller } from "@hotwired/stimulus";
import { reportOnboarding } from "./_onboarding_beacon.js";

export default class extends Controller {
    connect() {
        const key = `chippie_first_run_shown_${document.body?.dataset.currentBusinessId || ""}`;
        try {
            if (sessionStorage.getItem(key)) return;
            sessionStorage.setItem(key, "1");
        } catch {
            // Storage unavailable: report this showing anyway.
        }
        reportOnboarding("first_run_shown");
    }
}
